import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import XLSX from "xlsx";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Custom SVG Icons for Notion styling
const TextIcon = () => (
  <span className="text-gray-400 font-mono font-bold text-[11px] mr-1.5 w-4 inline-block text-center border border-gray-200 rounded px-0.5 select-none">Aa</span>
);
const TagIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400 mr-1.5 select-none" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 7h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);
const HashIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400 mr-1.5 select-none" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
  </svg>
);
const CalendarIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400 mr-1.5 select-none" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);
const SearchIcon = () => (
  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);
const ChevronDownIcon = () => (
  <svg className="w-3 h-3 text-gray-400 select-none ml-1.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);
const PlusIcon = () => (
  <svg className="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
  </svg>
);
const TrashIcon = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);
const DoubleChevronRightIcon = () => (
  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
  </svg>
);
const RefreshIcon = () => (
  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 1121.21 7.89M9 11l3-3 3 3" />
  </svg>
);
const FileIcon = () => (
  <svg className="w-4 h-4 text-[#008069]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);
const ChatBubbleIcon = () => (
  <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
);

export default function CampanasCobros() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [sheets, setSheets] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState("");
  const [readedData, setReadedData] = useState([]);
  const [selectedPhoneColumn, setSelectedPhoneColumn] = useState("");

  // Campaign select modal states
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [modalCampaignSearch, setModalCampaignSearch] = useState("");
  const [modalCampaignDate, setModalCampaignDate] = useState("");

  // Search & dynamic filter states
  const [search, setSearch] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filters, setFilters] = useState([]); // Array of { id, column, operator, value }
  const [showAddFilterDropdown, setShowAddFilterDropdown] = useState(false);
  const [activeFilterIdOpen, setActiveFilterIdOpen] = useState(null);

  // In-place cell editing states
  const [editingCell, setEditingCell] = useState({ rowIndex: null, column: null });
  const [editingValue, setEditingValue] = useState("");

  // Side drawer for detail peak
  const [activeRow, setActiveRow] = useState(null);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [verifyingWaid, setVerifyingWaid] = useState({});
  const [waidErrors, setWaidErrors] = useState({});

  // Sorting
  const [sortConfig, setSortConfig] = useState({ column: null, direction: 'asc' });

  // Refs for closing dropdowns
  const addFilterRef = useRef(null);
  const searchBoxRef = useRef(null);
  const lastVerifiedSheetRef = useRef("");

  // Split campaign string into name and date objects
  const parseCampaignName = (campaignStr) => {
    if (!campaignStr) return { name: "", dateStr: "", dateObj: null, formattedDate: "" };

    const idx = campaignStr.toLowerCase().indexOf(".xlsx");
    let name = campaignStr;
    let dateStr = "";
    let dateObj = null;

    if (idx !== -1) {
      name = campaignStr.substring(0, idx + 5); // Includes ".xlsx"
      dateStr = campaignStr.substring(idx + 5).trim();
    }

    if (dateStr) {
      try {
        dateObj = new Date(dateStr);
      } catch (e) {
        console.error("Error parsing campaign date", e);
      }
    }

    const formattedDate = (dateObj && !isNaN(dateObj.getTime()))
      ? dateObj.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      })
      : dateStr || "Fecha desconocida";

    return { name, dateStr, dateObj, formattedDate };
  };

  // Load list of sheets (uploaded excel campaigns)
  useEffect(() => {
    async function loadSheets() {
      const config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      };
      try {
        const sheetsRes = await axios.get(process.env.REACT_APP_BACKEND_API + "/customexcel", config);
        if (sheetsRes.data) {
          // Sort sheets by date descending so the latest campaign is first by default
          const sortedSheets = [...sheetsRes.data].sort((a, b) => {
            const dateA = parseCampaignName(a).dateObj;
            const dateB = parseCampaignName(b).dateObj;
            const timeA = dateA && !isNaN(dateA.getTime()) ? dateA.getTime() : 0;
            const timeB = dateB && !isNaN(dateB.getTime()) ? dateB.getTime() : 0;
            return timeB - timeA;
          });
          setSheets(sortedSheets);
          if (sortedSheets.length > 0) {
            setSelectedSheet(sortedSheets[0]);
          }
        }
      } catch (err) {
        console.error("Error loading sheets", err);
      }
    }

    if (user && user.accessToken) {
      loadSheets();
    }
  }, [user]);

  // Load active sheet's data
  useEffect(() => {
    if (!selectedSheet) return;

    async function loadSheetData() {
      const config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      };
      try {
        const baseUrl = process.env.REACT_APP_BACKEND_API + "/customexcel/" + selectedSheet;
        let url = baseUrl;
        // If the user is neither admin nor supervisor department, filter by their own ejecutivoCobro
        if (!user?.roles?.includes("ROLE_ADMIN") && !user?.roles?.includes("ROLE_SUPERVISOR_DEPARTAMENTO")) {
          const ejecutivoFirstName = encodeURIComponent(user?.ejecutivo?.firstName || "");
          if (ejecutivoFirstName) {
            url = `${baseUrl}?ejecutivoCobro=${ejecutivoFirstName}`;
          }
        }
        const res = await axios.get(url, config);
        if (res.data) {
          const mapped = res.data.map(row => ({
            ...row,
            checked: row.checked || false,
            messageStatus: row.messageStatus || [
              { id: 0, sentTemplate: "Sin plantillas", status: "not sent" }
            ]
          }));
          setReadedData(mapped);

          setActiveRow(null);
          setActiveRowIndex(null);

          // Auto-detect the phone column using keyword matching and digit profiles
          const detected = detectPhoneColumn(mapped);
          setSelectedPhoneColumn(detected);
        }
      } catch (err) {
        console.error("Error loading sheet details", err);
        toast.error("Error al cargar los datos de la campaña");
      }
    }

    loadSheetData();
  }, [selectedSheet, user.accessToken]);

  // Handle outside clicks to close autocomplete suggestions and filter lists
  useEffect(() => {
    function handleClickOutside(event) {
      if (addFilterRef.current && !addFilterRef.current.contains(event.target)) {
        setShowAddFilterDropdown(false);
      }
      if (searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Columns helper
  const dataColumnNames = (data) => {
    if (data && data.length > 0) {
      return Object.keys(data[0]).filter(k => k !== "checked" && k !== "sheettitle" && k !== "_id" && k !== "messageStatus");
    }
    return [];
  };

  const getColumnIcon = (colName) => {
    const name = colName.toLowerCase();
    if (name.includes("fecha") || name.includes("date") || name.includes("vencimiento")) {
      return <CalendarIcon />;
    }
    if (name.includes("id") || name.includes("nro") || name.includes("monto") || name.includes("balance") || name.includes("saldo") || name.includes("exigible")) {
      return <HashIcon />;
    }
    return <TextIcon />;
  };

  // Resolves the phone column dynamically
  const detectPhoneColumn = (data) => {
    if (!data || data.length === 0) return "";
    const cols = Object.keys(data[0]).filter(k => k !== "checked" && k !== "sheettitle" && k !== "_id" && k !== "messageStatus");

    // Keyword exact / suffix checks
    const keywords = ["telefono", "teléfono", "tel", "phone", "celular", "cel", "movil", "móvil", "contacto", "contact"];
    for (const kw of keywords) {
      const match = cols.find(c => c.toLowerCase() === kw);
      if (match) return match;
    }
    // Substring checks
    for (const kw of keywords) {
      const match = cols.find(c => c.toLowerCase().includes(kw));
      if (match) return match;
    }
    // Content value numeric verification (7-15 digits)
    for (const col of cols) {
      const hasPhoneLike = data.slice(0, 5).some(row => {
        const val = String(row[col] || "").replace(/\s/g, "");
        return /^\+?\d{7,15}$/.test(val);
      });
      if (hasPhoneLike) return col;
    }
    // Fallback
    return cols[0] || "";
  };

  // Navigates to Chat View routing using phone number as the URL param `:wa_id`
  const navigateToChat = (phoneNumber) => {
    if (!phoneNumber) return;
    const cleanPhone = String(phoneNumber).replace(/\D/g, ""); // Keep digits only
    const basePath = user?.roles?.includes("ROLE_ADMIN") ? "/admin/chat/" : "/dashboard/chat/";
    navigate(basePath + cleanPhone);
  };

  // Checkbox interactions
  const checkIndividual = (e, index) => {
    const updated = readedData.map((row, rowIndex) => {
      if (rowIndex === index) {
        return { ...row, checked: e.target.checked };
      }
      return row;
    });
    setReadedData(updated);
    if (activeRowIndex === index) {
      setActiveRow({ ...activeRow, checked: e.target.checked });
    }
  };

  const checkAll = (e) => {
    const checked = e.target.checked;
    setReadedData(readedData.map(row => ({
      ...row,
      checked: checked
    })));
  };

  const exportSelectionToExcel = () => {
    const selected = readedData.filter(row => row.checked);
    if (selected.length === 0) {
      toast.warning("No hay filas seleccionadas para exportar");
      return;
    }

    // Map each selected row to a clean object for the Excel sheet
    const exportData = selected.map(row => {
      const cleanRow = {};

      // Add all standard dynamic columns
      allColumns.forEach(col => {
        cleanRow[col] = row[col] || "";
      });

      // Add message status as a formatted string
      if (row.messageStatus && row.messageStatus.length > 0) {
        cleanRow["Estatus Mensaje"] = row.messageStatus
          .map(s => {
            const tName = s.sentTemplate || s.sendTemplate || "Plantilla";
            return `${tName}: ${s.status}`;
          })
          .join(" | ");
      } else {
        cleanRow["Estatus Mensaje"] = "Sin plantillas";
      }

      // Add verification error status
      let rowErrorStatus = "Sin verificar";
      const isAnyChecking = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === "checking");
      if (isAnyChecking) {
        rowErrorStatus = "Verificando...";
      } else {
        const hasError = row.messageStatus?.some(s => {
          const isVerificationError = s.id && verifyingWaid[s.id] === "error";
          const isFailedStatus = s.status?.toLowerCase() === "failed" || s.status?.toLowerCase() === "error";
          return isVerificationError || isFailedStatus;
        });
        const hasVerifiedOk = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === "verified");
        if (hasError) {
          rowErrorStatus = "Con Error";
        } else if (hasVerifiedOk) {
          rowErrorStatus = "Sin Error (OK)";
        }
      }
      cleanRow["Estatus Error"] = rowErrorStatus;

      return cleanRow;
    });

    try {
      // Create workbook and sheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Seleccion");

      // Determine file name based on campaign name
      const campaignName = parseCampaignName(selectedSheet).name || "campana";
      const cleanName = campaignName.replace(".xlsx", "").trim();
      const fileName = `${cleanName}_seleccion_${Date.now()}.xlsx`;

      // Write file to device
      XLSX.writeFile(workbook, fileName, { compression: true });
      toast.success("Selección exportada exitosamente a Excel");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("Error al exportar a Excel");
    }
  };

  // Double click cell editing
  const triggerEditCell = (rowIndex, column, value) => {
    setEditingCell({ rowIndex, column });
    setEditingValue(value || "");
  };

  const saveCellEdit = (rowIndex, column) => {
    const updatedRow = { ...readedData[rowIndex], [column]: editingValue };
    const updatedData = [...readedData];
    updatedData[rowIndex] = updatedRow;
    setReadedData(updatedData);

    updateRowAPI(updatedRow);
    setEditingCell({ rowIndex: null, column: null });

    if (activeRowIndex === rowIndex) {
      setActiveRow(updatedRow);
    }
  };

  const updateRowAPI = (row) => {
    let rowCopyWithoutID = { ...row };
    delete rowCopyWithoutID._id;
    try {
      fetch(process.env.REACT_APP_BACKEND_API + "/customexcel/" + row._id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": user.accessToken,
        },
        body: JSON.stringify(rowCopyWithoutID),
      }).then((response) => {
        if (!response.ok) {
          toast.error("Error al guardar cambios de la celda");
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleVerifyMessageStatus = async (status, indexToVerify) => {
    if (!status || !status.id || status.id === 0) return;
    const waid = status.id;
    setVerifyingWaid(prev => ({ ...prev, [waid]: 'checking' }));
    try {
      const config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      };
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_API}/messages/wamid/${waid}`, config);
      const apiRes = res.data;

      // Extract inner data if response contains success/data fields
      const messageData = apiRes && apiRes.success ? apiRes.data : apiRes;

      // Verify message does not have error
      const hasError = !messageData ||
        messageData.error ||
        messageData.status === 'failed' ||
        messageData.message_status === 'failed' ||
        messageData.errorCode ||
        messageData.errorMessage;

      if (hasError) {
        let errorMsg = "Mensaje con error";
        if (messageData?.error) {
          errorMsg = messageData.error.details || messageData.error.message || messageData.error.title || errorMsg;
        } else if (messageData?.errorMessage) {
          errorMsg = messageData.errorMessage;
        }
        setVerifyingWaid(prev => ({ ...prev, [waid]: 'error' }));
        setWaidErrors(prev => ({ ...prev, [waid]: errorMsg }));
      } else {
        setVerifyingWaid(prev => ({ ...prev, [waid]: 'verified' }));
        const newStatusStr = messageData.status || messageData.message_status || status.status;

        setReadedData(prevData => {
          const updatedData = [...prevData];
          const currentRow = updatedData[indexToVerify];
          if (currentRow && currentRow.messageStatus) {
            const hasChanged = currentRow.messageStatus.some(s => s.id === waid && s.status !== newStatusStr);
            if (hasChanged) {
              const updatedStatusList = currentRow.messageStatus.map(s =>
                s.id === waid ? { ...s, status: newStatusStr } : s
              );
              const updatedRow = { ...currentRow, messageStatus: updatedStatusList };
              updatedData[indexToVerify] = updatedRow;

              setActiveRow(prevActive => {
                if (prevActive && prevActive._id === currentRow._id) {
                  return updatedRow;
                }
                return prevActive;
              });

              updateRowAPI(updatedRow);
            }
          }
          return updatedData;
        });
      }
    } catch (err) {
      console.error("Error verifying message status", err);
      setVerifyingWaid(prev => ({ ...prev, [waid]: 'error' }));
      const errorMsg = err.response?.data?.message || err.message || "Error de red/servidor";
      setWaidErrors(prev => ({ ...prev, [waid]: errorMsg }));
    }
  };

  // Clear verification cache when loading a new sheet campaign
  useEffect(() => {
    setVerifyingWaid({});
    setWaidErrors({});
    lastVerifiedSheetRef.current = "";
  }, [selectedSheet]);

  // Background verify all messages in the campaign when loaded
  useEffect(() => {
    if (!selectedSheet || !readedData || readedData.length === 0) return;

    // Check if the loaded data matches the selected sheet
    const loadedSheetTitle = readedData[0]?.sheettitle || "";
    if (loadedSheetTitle !== selectedSheet) return;

    // Check if we already started verification for this sheet
    if (lastVerifiedSheetRef.current === selectedSheet) return;
    lastVerifiedSheetRef.current = selectedSheet;

    // Scan readedData for message status IDs that need validation
    const messagesToVerify = [];
    readedData.forEach((row, rowIndex) => {
      if (row.messageStatus) {
        row.messageStatus.forEach(status => {
          if (status.id && status.id !== 0) {
            messagesToVerify.push({ status, rowIndex });
          }
        });
      }
    });

    if (messagesToVerify.length === 0) return;

    // Filter out messages that are already checking or verified
    const pendingMessages = messagesToVerify.filter(
      item => !verifyingWaid[item.status.id]
    );

    if (pendingMessages.length === 0) return;

    let index = 0;
    const concurrency = 4; // Check up to 4 messages concurrently

    const runWorker = async () => {
      while (index < pendingMessages.length) {
        const currentItem = pendingMessages[index++];
        if (!currentItem) break;

        // Verify in background
        await handleVerifyMessageStatus(currentItem.status, currentItem.rowIndex);
      }
    };

    // Spawn workers
    for (let i = 0; i < Math.min(concurrency, pendingMessages.length); i++) {
      runWorker();
    }
  }, [selectedSheet, readedData]);

  // Sorting
  const handleSort = (columnName) => {
    let direction = 'asc';
    if (sortConfig.column === columnName && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ column: columnName, direction });
  };

  // Filter creation
  const addFilter = (colName) => {
    const newFilter = {
      id: Date.now(),
      column: colName,
      operator: (colName === "messageStatus" || colName === "errorStatus") ? "is" : "contains",
      value: colName === "messageStatus" ? "sent" : colName === "errorStatus" ? "error" : ""
    };
    setFilters([...filters, newFilter]);
    setShowAddFilterDropdown(false);
    setActiveFilterIdOpen(newFilter.id);
  };

  const updateFilter = (id, fields) => {
    setFilters(filters.map(f => f.id === id ? { ...f, ...fields } : f));
  };

  const deleteFilter = (id) => {
    setFilters(filters.filter(f => f.id !== id));
    if (activeFilterIdOpen === id) setActiveFilterIdOpen(null);
  };

  const clearAllFilters = () => {
    setFilters([]);
    setSearch("");
    setActiveFilterIdOpen(null);
  };

  // Autocomplete matching logic
  const allColumns = dataColumnNames(readedData);
  const nameColumn = allColumns.find(c => {
    const low = c.toLowerCase();
    return low.includes("asegurado") || low.includes("name") || low.includes("nombre") || low.includes("cliente");
  });
  const phoneColumn = selectedPhoneColumn;

  const getSuggestions = () => {
    if (!search || search.trim() === "") return [];
    const q = search.toLowerCase();
    const matches = [];

    for (let i = 0; i < readedData.length; i++) {
      const row = readedData[i];
      const matchesSearch = Object.keys(row).some(key => {
        if (key === "checked" || key === "_id" || key === "sheettitle" || key === "messageStatus") return false;
        return String(row[key] || "").toLowerCase().includes(q);
      });
      if (matchesSearch) {
        matches.push({ row, index: i });
      }
      if (matches.length >= 8) break; // limit to top 8 suggestions
    }
    return matches;
  };

  const suggestions = getSuggestions();

  const getRowSuggestionText = (row) => {
    const nameVal = nameColumn ? row[nameColumn] : "";
    const phoneVal = phoneColumn ? row[phoneColumn] : "";

    if (nameVal && phoneVal) return `${nameVal} (${phoneVal})`;
    if (nameVal) return nameVal;
    if (phoneVal) return `Tel: ${phoneVal}`;

    return Object.keys(row)
      .filter(k => k !== "checked" && k !== "sheettitle" && k !== "_id" && k !== "messageStatus")
      .slice(0, 2)
      .map(k => row[k])
      .join(" - ");
  };

  const handleSuggestionClick = (row, index) => {
    setActiveRow(row);
    setActiveRowIndex(index);

    const targetQuery = phoneColumn && row[phoneColumn] ? String(row[phoneColumn]) : (nameColumn && row[nameColumn] ? String(row[nameColumn]) : "");
    setSearch(targetQuery);
    setShowSuggestions(false);
  };

  // Filter and sort the loaded data array
  const getProcessedData = () => {
    let result = [...readedData];

    if (search) {
      const q = search.toLowerCase();
      result = result.filter(row => {
        return Object.keys(row).some(key => {
          if (key === "checked" || key === "_id" || key === "sheettitle") return false;
          if (key === "messageStatus") {
            return row.messageStatus?.some(s => {
              const tName = s.sentTemplate || s.sendTemplate || "";
              const statusStr = s.status?.toLowerCase() || "";
              const isVerificationError = s.id && verifyingWaid[s.id] === 'error';
              const effectiveStatus = isVerificationError ? 'error' : statusStr;
              return tName.toLowerCase().includes(q) || effectiveStatus.includes(q);
            });
          }
          return String(row[key] || "").toLowerCase().includes(q);
        });
      });
    }

    filters.forEach(filter => {
      if (!filter.column) return;
      const val = filter.value.toLowerCase();

      result = result.filter(row => {
        if (filter.column === "messageStatus") {
          const statuses = row.messageStatus?.map(s => {
            const statusStr = s.status.toLowerCase();
            const isVerificationError = s.id && verifyingWaid[s.id] === 'error';
            return isVerificationError ? 'error' : statusStr;
          }) || [];

          const checkStatusMatch = (statusVal, filterVal) => {
            if (filterVal === 'failed' || filterVal === 'error') {
              return statusVal === 'failed' || statusVal === 'error';
            }
            return statusVal === filterVal;
          };

          if (filter.operator === "is_empty") return statuses.length === 0;
          if (filter.operator === "is_not_empty") return statuses.length > 0;
          if (statuses.length === 0 && filter.operator === "is") return val === "not sent" || val === "sin plantillas";

          switch (filter.operator) {
            case "is": return statuses.some(s => checkStatusMatch(s, val));
            case "is_not": return !statuses.some(s => checkStatusMatch(s, val));
            case "contains": return statuses.some(s => s.includes(val) || (val === 'failed' && s === 'error') || (val === 'error' && s === 'failed'));
            case "not_contains": return !statuses.some(s => s.includes(val) || (val === 'failed' && s === 'error') || (val === 'error' && s === 'failed'));
            default: return true;
          }
        } else if (filter.column === "errorStatus") {
          let rowErrorStatus = 'pending';
          const isAnyChecking = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === 'checking');

          if (isAnyChecking) {
            rowErrorStatus = 'checking';
          } else {
            const hasError = row.messageStatus?.some(s => {
              const isVerificationError = s.id && verifyingWaid[s.id] === 'error';
              const isFailedStatus = s.status?.toLowerCase() === 'failed' || s.status?.toLowerCase() === 'error';
              return isVerificationError || isFailedStatus;
            });
            const hasVerifiedOk = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === 'verified');

            if (hasError) {
              rowErrorStatus = 'error';
            } else if (hasVerifiedOk) {
              rowErrorStatus = 'ok';
            }
          }

          if (filter.operator === "is_empty") return false;
          if (filter.operator === "is_not_empty") return true;

          switch (filter.operator) {
            case "is": return rowErrorStatus === val;
            case "is_not": return rowErrorStatus !== val;
            default: return true;
          }
        } else {
          const cellVal = String(row[filter.column] || "").toLowerCase();
          switch (filter.operator) {
            case "contains": return cellVal.includes(val);
            case "not_contains": return !cellVal.includes(val);
            case "is": return cellVal === val;
            case "is_not": return cellVal !== val;
            case "is_empty": return cellVal.trim() === "";
            case "is_not_empty": return cellVal.trim() !== "";
            default: return true;
          }
        }
      });
    });

    if (sortConfig.column) {
      result.sort((a, b) => {
        let valA = a[sortConfig.column];
        let valB = b[sortConfig.column];

        if (sortConfig.column === "errorStatus") {
          const getRowErrorPriority = (row) => {
            const isAnyChecking = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === 'checking');
            if (isAnyChecking) return 1;
            const hasError = row.messageStatus?.some(s => {
              const isVerificationError = s.id && verifyingWaid[s.id] === 'error';
              const isFailedStatus = s.status?.toLowerCase() === 'failed' || s.status?.toLowerCase() === 'error';
              return isVerificationError || isFailedStatus;
            });
            if (hasError) return 0;
            const hasVerifiedOk = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === 'verified');
            if (hasVerifiedOk) return 2;
            return 3;
          };
          valA = getRowErrorPriority(a);
          valB = getRowErrorPriority(b);
          return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
        }

        if (typeof valA === "number" && typeof valB === "number") {
          return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
        }
        valA = String(valA || "").toLowerCase();
        valB = String(valB || "").toLowerCase();

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    return result;
  };

  const processedData = getProcessedData();

  const getStatusBadgeStyle = (status) => {
    const s = String(status || "").toLowerCase();
    if (s.includes("read") || s.includes("leido") || s.includes("delivered") || s.includes("entregado")) {
      return "bg-[#eaf6ec] text-[#2b6e37]";
    }
    if (s.includes("sent") || s.includes("enviado") || s.includes("accepted") || s.includes("aceptado")) {
      return "bg-[#e8f4fc] text-[#1e578c]";
    }
    if (s.includes("failed") || s.includes("fallo") || s.includes("error")) {
      return "bg-[#fdf2f2] text-[#9b1c1c]";
    }
    return "bg-[#f1f1ef] text-[#787774]";
  };

  return (
    <div className="flex flex-col h-[calc(100vh-64px)] bg-[#fbfbfa] text-[#37352f] overflow-hidden font-sans">
      <ToastContainer position="bottom-right" autoClose={3000} />

      {/* Notion Top Control Panel */}
      <div className="flex flex-col border-b border-[#e9eded] bg-white px-6 py-4 space-y-3 shrink-0 shadow-sm">

        <div className="flex flex-wrap items-center justify-between gap-4">

          {/* Header titles */}
          <div className="flex items-center space-x-2.5">
            <div className="bg-[#e8f5e8] p-1.5 rounded-lg">
              <FileIcon />
            </div>
            <div className="flex flex-col">
              <h1 className="text-base font-semibold text-[#111b21]">Campañas de Cobros</h1>
              <span className="text-xs text-gray-500 font-medium select-none">Base de Datos estilo Notion vinculada a Chats</span>
            </div>
          </div>

          {/* Configuration toolbar */}
          <div className="flex flex-wrap items-center gap-3">

            {readedData.some(row => row.checked) && (
              <button
                type="button"
                onClick={exportSelectionToExcel}
                className="flex items-center space-x-1.5 bg-[#008069] hover:bg-[#006e5a] text-white px-2.5 py-1.5 rounded-md text-xs transition cursor-pointer select-none font-semibold shadow-sm border-0"
              >
                <span>Exportar Selección ({readedData.filter(row => row.checked).length})</span>
              </button>
            )}

            {/* Campaign Selector Modal Trigger Button (Not Bold) */}
            <div className="flex items-center space-x-1.5 bg-gray-50 hover:bg-gray-100 border border-[#e9eded] px-2.5 py-1.5 rounded-md text-xs transition cursor-pointer select-none"
              onClick={() => {
                setModalCampaignSearch("");
                setModalCampaignDate("");
                setShowCampaignModal(true);
              }}
            >
              <FileIcon />
              <span className="text-gray-500 font-normal">Campaña:</span>
              <span className="text-[#37352f] font-normal truncate max-w-[220px]">
                {parseCampaignName(selectedSheet).name || "Seleccionar campaña..."}
              </span>
              <ChevronDownIcon />
            </div>

          </div>
        </div>

        {/* Filters control & Autocomplete search row */}
        <div className="flex flex-wrap items-center gap-3 pt-2 border-t border-gray-100">

          <div className="flex items-center space-x-2">

            {/* Search Input with Autocomplete list */}
            <div className="relative" ref={searchBoxRef}>
              <div className="flex items-center space-x-2 border border-gray-200 rounded-md bg-gray-50 px-2.5 py-1.5 w-[280px]">
                <SearchIcon />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setShowSuggestions(true);
                  }}
                  onFocus={() => setShowSuggestions(true)}
                  placeholder="Buscar asegurados o teléfonos..."
                  className="bg-transparent border-none p-0 outline-none text-xs w-full text-[#37352f] focus:ring-0 placeholder-gray-400"
                />
              </div>

              {/* Autocomplete Dropdown */}
              {showSuggestions && suggestions.length > 0 && (
                <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-[#e9eded] rounded-md shadow-lg z-30 py-1 max-h-60 overflow-y-auto">
                  {suggestions.map((item, sIdx) => {
                    const text = getRowSuggestionText(item.row);
                    return (
                      <button
                        key={sIdx}
                        type="button"
                        onClick={() => handleSuggestionClick(item.row, item.index)}
                        className="w-full text-left px-3 py-2 hover:bg-[#f7f7f5] text-xs text-[#37352f] flex justify-between items-center transition-colors border-b border-gray-50 last:border-0"
                      >
                        <span className="font-semibold truncate mr-2">{text}</span>
                        {phoneColumn && item.row[phoneColumn] && (
                          <span className="text-[10px] text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded font-mono shrink-0 select-none">
                            {item.row[phoneColumn]}
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            {/* + Add Filter button */}
            <div className="relative" ref={addFilterRef}>
              <button
                onClick={() => setShowAddFilterDropdown(!showAddFilterDropdown)}
                className="hover:bg-gray-100 text-[#5f5e5b] border border-[#e9eded] bg-white rounded-md text-xs font-semibold px-2.5 py-1.5 inline-flex items-center transition"
              >
                <PlusIcon /> Filtro
              </button>

              {showAddFilterDropdown && (
                <div className="absolute left-0 mt-1.5 w-56 bg-white border border-[#e9eded] rounded-lg shadow-xl z-20 max-h-[300px] overflow-y-auto py-1">
                  <div className="px-3 py-1.5 text-[10px] font-bold text-gray-400 uppercase select-none tracking-wider border-b border-gray-100">
                    Filtrar por columna
                  </div>

                  <button
                    onClick={() => addFilter("messageStatus")}
                    className="w-full text-left px-3 py-1.5 text-xs hover:bg-[#f7f7f5] flex items-center transition"
                  >
                    <TagIcon /> <span className="font-semibold">messageStatus</span>
                  </button>

                  <button
                    onClick={() => addFilter("errorStatus")}
                    className="w-full text-left px-3 py-1.5 text-xs hover:bg-[#f7f7f5] flex items-center transition"
                  >
                    <TagIcon /> <span className="font-semibold">errorStatus</span>
                  </button>

                  {allColumns.map((col, idx) => (
                    <button
                      key={idx}
                      onClick={() => addFilter(col)}
                      className="w-full text-left px-3 py-1.5 text-xs hover:bg-[#f7f7f5] flex items-center transition"
                    >
                      {getColumnIcon(col)} <span>{col}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Reset Filter Button */}
            {(filters.length > 0 || search) && (
              <button
                onClick={clearAllFilters}
                className="hover:bg-red-50 text-red-600 hover:text-red-700 rounded-md text-xs font-semibold px-2.5 py-1.5 transition flex items-center"
              >
                <RefreshIcon /> &nbsp;Limpiar filtros
              </button>
            )}

          </div>

          {/* Active Filter Pills List */}
          <div className="flex flex-wrap items-center gap-1.5">
            {filters.map((filter) => {
              const isOpen = activeFilterIdOpen === filter.id;
              return (
                <div key={filter.id} className="relative inline-flex items-center animate-fadeIn">

                  <span className="bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs px-2.5 py-0.5 rounded-full inline-flex items-center font-medium border border-gray-200 select-none">
                    <span onClick={() => setActiveFilterIdOpen(isOpen ? null : filter.id)} className="cursor-pointer mr-1 hover:underline">
                      {filter.column}:
                      <span className="text-[#008069] ml-1 font-semibold">
                        {filter.operator === "contains" ? "contiene" :
                          filter.operator === "not_contains" ? "no contiene" :
                            filter.operator === "is" ? "es" :
                              filter.operator === "is_not" ? "no es" :
                                filter.operator === "is_empty" ? "vacío" : "no vacío"}
                      </span>
                      {filter.operator !== "is_empty" && filter.operator !== "is_not_empty" && (
                        <span className="text-gray-500 font-normal ml-1">"{filter.value}"</span>
                      )}
                    </span>
                    <button
                      onClick={() => deleteFilter(filter.id)}
                      className="ml-1 text-gray-400 hover:text-gray-600 font-bold"
                    >
                      ×
                    </button>
                  </span>

                  {isOpen && (
                    <div className="absolute left-0 top-full mt-1.5 w-64 bg-white border border-[#e9eded] rounded-lg shadow-xl z-20 p-3 flex flex-col space-y-2.5">
                      <div className="flex items-center justify-between border-b border-gray-100 pb-1.5">
                        <span className="text-xs font-bold text-gray-500 uppercase">{filter.column}</span>
                        <button onClick={() => deleteFilter(filter.id)} className="text-gray-400 hover:text-red-500">
                          <TrashIcon />
                        </button>
                      </div>

                      <div className="flex flex-col space-y-1">
                        <label className="text-[10px] font-bold text-gray-400 uppercase">Condición</label>
                        <select
                          value={filter.operator}
                          onChange={(e) => updateFilter(filter.id, { operator: e.target.value })}
                          className="bg-gray-50 border border-gray-200 rounded-md p-1.5 text-xs outline-none focus:ring-1 focus:ring-[#008069] w-full cursor-pointer"
                        >
                          <option value="contains">Contiene</option>
                          <option value="not_contains">No contiene</option>
                          <option value="is">Es</option>
                          <option value="is_not">No es</option>
                          <option value="is_empty">Está vacío</option>
                          <option value="is_not_empty">No está vacío</option>
                        </select>
                      </div>

                      {filter.operator !== "is_empty" && filter.operator !== "is_not_empty" && (
                        <div className="flex flex-col space-y-1">
                          <label className="text-[10px] font-bold text-gray-400 uppercase">Valor</label>
                          {(filter.column === "messageStatus" || filter.column === "errorStatus") ? (
                            filter.column === "messageStatus" ? (
                              <select
                                value={filter.value}
                                onChange={(e) => updateFilter(filter.id, { value: e.target.value })}
                                className="bg-gray-50 border border-gray-200 rounded-md p-1.5 text-xs outline-none focus:ring-1 focus:ring-[#008069] w-full cursor-pointer"
                              >
                                <option value="sent">sent (enviado)</option>
                                <option value="delivered">delivered (entregado)</option>
                                <option value="read">read (leído)</option>
                                <option value="failed">failed (falló)</option>
                                <option value="error">error (con error)</option>
                                <option value="not sent">not sent (sin enviar)</option>
                              </select>
                            ) : (
                              <select
                                value={filter.value}
                                onChange={(e) => updateFilter(filter.id, { value: e.target.value })}
                                className="bg-gray-50 border border-gray-200 rounded-md p-1.5 text-xs outline-none focus:ring-1 focus:ring-[#008069] w-full cursor-pointer"
                              >
                                <option value="error">error (con error)</option>
                                <option value="ok">ok (sin error)</option>
                                <option value="pending">pending (sin verificar)</option>
                              </select>
                            )
                          ) : (
                            <input
                              type="text"
                              value={filter.value}
                              onChange={(e) => updateFilter(filter.id, { value: e.target.value })}
                              className="bg-gray-50 border border-gray-200 rounded-md p-1.5 text-xs outline-none focus:ring-1 focus:ring-[#008069] w-full"
                              placeholder="Escribe un valor..."
                              autoFocus
                            />
                          )}
                        </div>
                      )}

                      <button
                        onClick={() => setActiveFilterIdOpen(null)}
                        className="bg-[#008069] text-white text-xs font-semibold rounded-md py-1.5 w-full hover:bg-[#006d5a] transition"
                      >
                        Listo
                      </button>
                    </div>
                  )}

                </div>
              );
            })}
          </div>

        </div>

      </div>

      {/* Notion Grid Table */}
      <div className="flex-1 flex overflow-hidden relative bg-white">

        <div className="flex-1 overflow-auto minimal-horizontal-scroll">
          <table className="min-w-full border-collapse border-spacing-0 table-auto">

            {/* Headers */}
            <thead className="bg-[#f7f7f5] sticky top-0 z-10 shadow-sm border-b border-[#e9eded]">
              <tr className="divide-x divide-[#e9eded]">

                {/* Select All Checkbox Header */}
                <th className="w-11 px-2.5 py-2 text-center select-none bg-[#f7f7f5]">
                  <div className="flex items-center justify-center">
                    <input
                      type="checkbox"
                      onChange={checkAll}
                      className="w-3.5 h-3.5 text-[#008069] border-gray-300 rounded focus:ring-[#008069] cursor-pointer"
                    />
                  </div>
                </th>

                {/* Open Side peek action header */}
                <th className="w-16 px-2 py-2 text-center text-xs font-semibold text-[#5f5e5b] select-none bg-[#f7f7f5]">
                  Abrir
                </th>

                {/* messageStatus Header */}
                <th
                  onClick={() => handleSort("messageStatus")}
                  className="px-3 py-2 text-left text-xs font-semibold text-[#5f5e5b] select-none cursor-pointer hover:bg-[#efefe9] transition group"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <TagIcon />
                      <span>messageStatus</span>
                    </div>
                    {sortConfig.column === "messageStatus" && (
                      <span className="text-[10px] text-gray-500 font-bold ml-1">
                        {sortConfig.direction === 'asc' ? '▲' : '▼'}
                      </span>
                    )}
                  </div>
                </th>

                {/* errorStatus Header */}
                <th
                  onClick={() => handleSort("errorStatus")}
                  className="px-3 py-2 text-left text-xs font-semibold text-[#5f5e5b] select-none cursor-pointer hover:bg-[#efefe9] transition group"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <TagIcon />
                      <span>errorStatus</span>
                    </div>
                    {sortConfig.column === "errorStatus" && (
                      <span className="text-[10px] text-gray-500 font-bold ml-1">
                        {sortConfig.direction === 'asc' ? '▲' : '▼'}
                      </span>
                    )}
                  </div>
                </th>

                {/* Dynamic dynamic headers */}
                {allColumns.map((colName, idx) => (
                  <th
                    key={idx}
                    onClick={() => handleSort(colName)}
                    className="px-3 py-2 text-left text-xs font-semibold text-[#5f5e5b] select-none cursor-pointer hover:bg-[#efefe9] transition group"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        {getColumnIcon(colName)}
                        <span>{colName}</span>
                      </div>

                      <span className="text-[10px] text-gray-400 hover:text-gray-800 p-0.5 ml-1 select-none font-bold">
                        {sortConfig.column === colName ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '⇅'}
                      </span>
                    </div>
                  </th>
                ))}

              </tr>
            </thead>

            {/* Body */}
            <tbody className="divide-y divide-[#e9eded]">
              {processedData.length > 0 ? (
                processedData.map((row, rIdx) => {
                  const isChecked = row.checked;
                  return (
                    <tr
                      key={row._id || rIdx}
                      className={`hover:bg-[#f7f7f5]/70 divide-x divide-[#e9eded] transition-colors ${isChecked ? 'bg-[#008069]/5' : ''}`}
                    >

                      {/* Checkbox column */}
                      <td className="w-11 px-2.5 py-1.5 text-center">
                        <div className="flex items-center justify-center">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={(e) => checkIndividual(e, rIdx)}
                            className="w-3.5 h-3.5 text-[#008069] border-gray-300 rounded focus:ring-[#008069] cursor-pointer"
                          />
                        </div>
                      </td>

                      {/* Open Drawer button */}
                      <td className="w-16 px-2 py-1.5 text-center">
                        <button
                          onClick={() => {
                            setActiveRow(row);
                            setActiveRowIndex(rIdx);
                          }}
                          className="text-xs bg-white hover:bg-gray-100 text-[#37352f] hover:text-[#008069] border border-gray-200 hover:border-[#008069] font-medium px-2 py-0.5 rounded shadow-sm transition inline-flex items-center justify-center w-full"
                        >
                          Abrir
                        </button>
                      </td>

                      {/* messageStatus cell */}
                      <td className="px-3 py-1.5 text-sm overflow-hidden text-ellipsis whitespace-nowrap min-w-[180px] max-w-[280px]">
                        <div className="flex flex-wrap gap-1">
                          {row.messageStatus && row.messageStatus.map((status, sIdx) => {
                            const tName = status.sentTemplate || status.sendTemplate || "Plantilla";
                            return (
                              <span
                                key={sIdx}
                                className={`text-[10px] font-semibold px-2 py-0.5 rounded-full select-none ${getStatusBadgeStyle(status.status)}`}
                                title={`${tName}: ${status.status}`}
                              >
                                {tName}: {status.status}
                              </span>
                            );
                          })}
                        </div>
                      </td>

                      {/* errorStatus cell */}
                      <td className="px-3 py-1.5 text-sm overflow-hidden text-ellipsis whitespace-nowrap min-w-[130px]">
                        {(() => {
                          const isAnyChecking = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === 'checking');

                          if (isAnyChecking) {
                            return (
                              <div className="animate-pulse flex items-center space-x-2 py-1">
                                <div className="h-3.5 w-16 bg-gray-200 rounded-full"></div>
                                <div className="h-2 w-2 bg-gray-300 rounded-full animate-ping"></div>
                              </div>
                            );
                          }

                          const hasError = row.messageStatus?.some(s => {
                            const isVerificationError = s.id && verifyingWaid[s.id] === 'error';
                            const isFailedStatus = s.status?.toLowerCase() === 'failed' || s.status?.toLowerCase() === 'error';
                            return isVerificationError || isFailedStatus;
                          });

                          const hasVerifiedOk = row.messageStatus?.some(s => s.id && verifyingWaid[s.id] === 'verified');

                          if (hasError) {
                            return (
                              <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full select-none bg-[#fdf2f2] text-[#9b1c1c] border border-red-100">
                                Con Error
                              </span>
                            );
                          } else if (hasVerifiedOk) {
                            return (
                              <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full select-none bg-[#eaf6ec] text-[#2b6e37] border border-green-100">
                                Sin Error (OK)
                              </span>
                            );
                          }

                          return (
                            <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full select-none bg-gray-50 text-gray-400 border border-gray-100">
                              Sin verificar
                            </span>
                          );
                        })()}
                      </td>

                      {/* Dynamic spreadsheet columns cells */}
                      {allColumns.map((colKey, cIdx) => {
                        const cellVal = row[colKey] || "";
                        const isEditing = editingCell.rowIndex === rIdx && editingCell.column === colKey;
                        const isPhone = colKey === selectedPhoneColumn;

                        return (
                          <td
                            key={cIdx}
                            onDoubleClick={() => {
                              if (!isPhone) triggerEditCell(rIdx, colKey, cellVal);
                            }}
                            className="px-3 py-1.5 text-sm text-[#37352f] truncate relative group/cell min-w-[150px] max-w-[320px] h-[36px]"
                            title={isPhone ? "Click para abrir chat" : "Doble click para editar celda"}
                          >
                            {isEditing ? (
                              <input
                                type="text"
                                value={editingValue}
                                onChange={(e) => setEditingValue(e.target.value)}
                                onBlur={() => saveCellEdit(rIdx, colKey)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") saveCellEdit(rIdx, colKey);
                                  if (e.key === "Escape") setEditingCell({ rowIndex: null, column: null });
                                }}
                                className="absolute inset-0 w-full h-full bg-white border border-[#2383e2] outline-none px-3 text-sm focus:ring-1 focus:ring-[#2383e2]"
                                autoFocus
                              />
                            ) : (
                              <div className="flex items-center justify-between w-full h-full">
                                {isPhone && cellVal ? (
                                  <button
                                    onClick={() => navigateToChat(cellVal)}
                                    className="text-blue-600 hover:text-blue-800 font-semibold hover:underline flex items-center space-x-1 focus:outline-none truncate"
                                  >
                                    <ChatBubbleIcon />
                                    <span className="truncate">{String(cellVal)}</span>
                                  </button>
                                ) : (
                                  <span className="truncate">{String(cellVal)}</span>
                                )}
                                {!isPhone && (
                                  <span className="opacity-0 group-hover/cell:opacity-100 text-[10px] text-gray-400 absolute right-2 select-none pointer-events-none">
                                    ✎
                                  </span>
                                )}
                              </div>
                            )}
                          </td>
                        );
                      })}

                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={allColumns.length + 4} className="text-center py-10 text-sm text-gray-500 font-medium bg-white">
                    {readedData.length === 0 ? "Cargando datos..." : "Ningún registro coincide con los filtros activos."}
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

        {/* Notion Side Peek Drawer for Row Detail */}
        {activeRow && (
          <div className="w-[380px] border-l border-[#e9eded] bg-white h-full shadow-2xl flex flex-col z-20 animate-fadeIn shrink-0">

            {/* Drawer Header */}
            <div className="flex items-center justify-between border-b border-[#e9eded] p-4 shrink-0 bg-gray-50">
              <div className="flex items-center space-x-1.5">
                <DoubleChevronRightIcon />
                <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">Detalle del Registro</span>
              </div>
              <button
                onClick={() => {
                  setActiveRow(null);
                  setActiveRowIndex(null);
                }}
                className="hover:bg-gray-200 p-1 rounded-md text-gray-500 transition"
              >
                ✕
              </button>
            </div>

            {/* Properties form contents */}
            <div className="flex-1 overflow-y-auto p-5 space-y-6 flex flex-col justify-between">

              <div className="space-y-4">
                <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider border-b border-gray-100 pb-1.5 flex items-center select-none">
                  Propiedades
                </h3>

                {/* Checkbox Property row */}
                <div className="flex items-start text-xs">
                  <div className="w-28 text-gray-400 font-medium py-1 select-none flex items-center shrink-0">
                    <svg className="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Seleccionado
                  </div>
                  <div className="flex-1 py-1">
                    <input
                      type="checkbox"
                      checked={activeRow.checked}
                      onChange={(e) => checkIndividual(e, activeRowIndex)}
                      className="w-4 h-4 text-[#008069] border-gray-300 rounded focus:ring-[#008069] cursor-pointer"
                    />
                  </div>
                </div>

                {/* messageStatus Property row */}
                <div className="flex items-start text-xs border-t border-gray-50 pt-2.5">
                  <div className="w-28 text-gray-400 font-medium py-1 select-none flex items-center shrink-0">
                    <TagIcon />
                    messageStatus
                  </div>
                  <div className="flex-1 flex flex-col space-y-1.5">
                    {activeRow.messageStatus && activeRow.messageStatus.map((status, sIdx) => {
                      const tName = status.sentTemplate || status.sendTemplate || "Plantilla";
                      const waid = status.id;
                      const hasWaid = waid && waid !== 0;
                      const verifyState = hasWaid ? verifyingWaid[waid] : null;
                      const errorMsg = hasWaid ? waidErrors[waid] : null;

                      return (
                        <div key={sIdx} className="flex items-center space-x-1.5 flex-wrap gap-y-1">
                          <span
                            className={`text-[10px] font-semibold px-2 py-0.5 rounded-full select-none ${getStatusBadgeStyle(status.status)}`}
                            title={`${tName}: ${status.status}`}
                          >
                            {tName}: {status.status}
                          </span>
                          {hasWaid && (
                            <button
                              type="button"
                              onClick={() => handleVerifyMessageStatus(status, activeRowIndex)}
                              disabled={verifyState === "checking"}
                              className={`text-[9px] px-1.5 py-0.5 rounded font-medium transition flex items-center space-x-0.5 border ${verifyState === "checking"
                                ? "bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed"
                                : verifyState === "verified"
                                  ? "bg-green-50 text-green-600 border-green-200 hover:bg-green-100/50 cursor-pointer"
                                  : verifyState === "error"
                                    ? "bg-red-50 text-red-600 border-red-200 hover:bg-red-100/50 cursor-pointer"
                                    : "bg-blue-50 text-blue-600 border-blue-200 hover:bg-blue-100/50 cursor-pointer"
                                }`}
                              title={
                                verifyState === "error"
                                  ? `Error de verificación: ${errorMsg || "Mensaje fallido o no encontrado"}. Haz clic para reintentar.`
                                  : verifyState === "verified"
                                    ? "Verificación exitosa (Sin error). Haz clic para volver a verificar."
                                    : "Haz clic para verificar estado y errores en WhatsApp"
                              }
                            >
                              {verifyState === "checking" && (
                                <svg className="animate-spin h-2.5 w-2.5 mr-0.5 text-gray-400" viewBox="0 0 24 24" fill="none">
                                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                </svg>
                              )}
                              <span>
                                {verifyState === "checking"
                                  ? "Verificando..."
                                  : verifyState === "verified"
                                    ? "✓ OK"
                                    : verifyState === "error"
                                      ? "⚠ Error"
                                      : "Verificar"}
                              </span>
                            </button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Dynamic properties lists */}
                {allColumns.map((colKey, idx) => {
                  const val = activeRow[colKey] || "";
                  const isPhone = colKey === selectedPhoneColumn;

                  return (
                    <div key={idx} className="flex items-start text-xs border-t border-gray-50 pt-2.5">
                      <div className="w-28 text-gray-400 font-medium py-1 select-none flex items-center truncate pr-1 shrink-0" title={colKey}>
                        {getColumnIcon(colKey)}
                        <span>{colKey}</span>
                      </div>
                      <div className="flex-1">
                        {isPhone ? (
                          <div className="flex items-center space-x-1.5 py-1">
                            <span className="font-semibold text-blue-600 font-mono text-xs">{val}</span>
                          </div>
                        ) : (
                          <input
                            type="text"
                            value={val}
                            onChange={(e) => {
                              const updatedRow = { ...activeRow, [colKey]: e.target.value };
                              setActiveRow(updatedRow);

                              const updatedData = [...readedData];
                              updatedData[activeRowIndex] = updatedRow;
                              setReadedData(updatedData);

                              updateRowAPI(updatedRow);
                            }}
                            className="w-full bg-transparent hover:bg-gray-50 focus:bg-white border-none focus:border focus:border-[#2383e2] rounded px-1.5 py-1 text-xs text-[#37352f] outline-none"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}

              </div>

              {/* Navigation Action Area */}
              {selectedPhoneColumn && activeRow[selectedPhoneColumn] && (
                <div className="pt-6 border-t border-gray-100 flex flex-col space-y-2">
                  <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider select-none">
                    Acción de WhatsApp
                  </h4>
                  <button
                    onClick={() => navigateToChat(activeRow[selectedPhoneColumn])}
                    className="w-full bg-[#008069] hover:bg-[#006d5a] text-white text-xs font-semibold py-2.5 px-4 rounded-md shadow-sm transition flex items-center justify-center space-x-2 focus:outline-none"
                  >
                    <ChatBubbleIcon />
                    <span>Abrir Chat con {activeRow[selectedPhoneColumn]}</span>
                  </button>
                </div>
              )}

            </div>
          </div>
        )}

      </div>

      {/* Campaigns Search Modal (with Autocomplete and Calendar Date filter) */}
      {showCampaignModal && (
        <div className="fixed inset-0 z-50 overflow-hidden flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeIn">
          <div className="bg-white rounded-lg border border-[#e9eded] shadow-2xl w-full max-w-lg mx-4 flex flex-col max-h-[80vh] overflow-hidden">

            {/* Modal Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-[#e9eded] bg-gray-50">
              <div className="flex items-center space-x-2">
                <FileIcon />
                <h2 className="text-sm font-semibold text-[#37352f]">Seleccionar Campaña</h2>
              </div>
              <button
                onClick={() => setShowCampaignModal(false)}
                className="text-gray-400 hover:text-gray-600 p-1 rounded-md transition"
              >
                ✕
              </button>
            </div>

            {/* Modal Filters Area */}
            <div className="p-4 border-b border-[#e9eded] space-y-3 bg-white">

              {/* Autocomplete Search input */}
              <div className="flex items-center space-x-2 border border-gray-200 rounded-md bg-gray-50 px-2.5 py-1.5">
                <SearchIcon />
                <input
                  type="text"
                  value={modalCampaignSearch}
                  onChange={(e) => setModalCampaignSearch(e.target.value)}
                  placeholder="Buscar campaña por nombre..."
                  className="bg-transparent border-none p-0 outline-none text-xs w-full text-[#37352f] focus:ring-0 placeholder-gray-400"
                />
              </div>

              {/* Date / Calendar Filter option */}
              <div className="flex items-center space-x-3 text-xs">
                <div className="flex items-center space-x-1.5 flex-1">
                  <span className="text-gray-500 select-none">Filtrar por fecha:</span>
                  <input
                    type="date"
                    value={modalCampaignDate}
                    onChange={(e) => setModalCampaignDate(e.target.value)}
                    className="border border-gray-200 rounded-md px-2 py-1 bg-gray-50 text-[#37352f] outline-none focus:ring-1 focus:ring-[#008069] flex-1 text-xs cursor-pointer"
                  />
                </div>
                {modalCampaignDate && (
                  <button
                    onClick={() => setModalCampaignDate("")}
                    className="text-red-500 hover:underline font-semibold"
                  >
                    Quitar fecha
                  </button>
                )}
              </div>

            </div>

            {/* Modal List Area */}
            <div className="flex-1 overflow-y-auto p-3 bg-gray-50/50 space-y-2 max-h-[45vh] minimal-horizontal-scroll">
              {(() => {
                const filtered = sheets.filter(sheet => {
                  const { name, dateObj } = parseCampaignName(sheet);

                  // Filter by name
                  if (modalCampaignSearch && !name.toLowerCase().includes(modalCampaignSearch.toLowerCase())) {
                    return false;
                  }

                  // Filter by date
                  if (modalCampaignDate) {
                    if (!dateObj || isNaN(dateObj.getTime())) return false;

                    // Format both as YYYY-MM-DD
                    const campaignYYYYMMDD = dateObj.toISOString().split('T')[0];
                    if (campaignYYYYMMDD !== modalCampaignDate) {
                      return false;
                    }
                  }

                  return true;
                });

                // Sort by default by date desc
                filtered.sort((a, b) => {
                  const dateA = parseCampaignName(a).dateObj;
                  const dateB = parseCampaignName(b).dateObj;
                  const timeA = dateA && !isNaN(dateA.getTime()) ? dateA.getTime() : 0;
                  const timeB = dateB && !isNaN(dateB.getTime()) ? dateB.getTime() : 0;
                  return timeB - timeA;
                });

                if (filtered.length === 0) {
                  return (
                    <div className="text-center py-8 text-xs text-gray-500 font-medium bg-white rounded-md border border-dashed border-gray-200">
                      No se encontraron campañas coincidentes.
                    </div>
                  );
                }

                return filtered.map((sheet, idx) => {
                  const { name, formattedDate } = parseCampaignName(sheet);
                  const isCurrent = sheet === selectedSheet;
                  return (
                    <button
                      key={idx}
                      type="button"
                      onClick={() => {
                        setSelectedSheet(sheet);
                        setShowCampaignModal(false);
                      }}
                      className={`w-full text-left px-4 py-3 bg-white rounded-md border transition flex flex-col space-y-1 hover:border-[#008069] hover:bg-emerald-50/5 ${isCurrent ? "border-[#008069] bg-emerald-50/10 shadow-sm" : "border-[#e9eded]"
                        }`}
                    >
                      <div className="flex items-center justify-between w-full">
                        <span className="font-semibold text-xs text-[#37352f] truncate flex-1 pr-2">
                          {name}
                        </span>
                        {isCurrent && (
                          <span className="text-[10px] text-emerald-600 bg-emerald-100 font-bold px-1.5 py-0.5 rounded select-none shrink-0">
                            Activo
                          </span>
                        )}
                      </div>
                      <div className="flex items-center text-[10px] text-gray-400">
                        <span className="font-normal font-sans">{formattedDate}</span>
                      </div>
                    </button>
                  );
                });
              })()}
            </div>

            {/* Modal Footer */}
            <div className="px-5 py-3 border-t border-[#e9eded] bg-white flex justify-end">
              <button
                onClick={() => setShowCampaignModal(false)}
                className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 px-3.5 py-1.5 rounded-md font-semibold transition"
              >
                Cerrar
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
}
